/**
 * @params Search Bar
 */

export default function() {
    const searchButton = $('.search-button--js');
    const searchBar = $('.header__search-nav');
    const searchInput = $('.header__search-bar-input');
    const menuItems = $('.header__nav');
    const closeButton = $('.header__search-bar-cancel--js');

    function openSearch(mustFocus) {
        menuItems.addClass('disappear');
        searchBar.addClass('visible');

        if (mustFocus) {
            searchInput.focus();
        }
    }

    function closeSearch() {
        searchBar.removeClass('visible');
        menuItems.removeClass('disappear');
        searchInput.val('');
    }

    searchButton.click(function() {
        openSearch(true);
    });

    closeButton.click(function() {
        closeSearch();
    });
}
